const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  siteUrl: import.meta.env.VITE_SITE_URL || 'http://localhost:5173',
  appName: import.meta.env.VITE_APP_NAME || 'Sanjoy',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  isDevelopment: import.meta.env.VITE_ENVIRONMENT !== 'production',
  isProduction: import.meta.env.VITE_ENVIRONMENT === 'production',
} as const;

export default env;
